import {
  Close,
  RemoveRedEyeRounded,
} from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { GridColDef, GridColumnVisibilityModel } from "@mui/x-data-grid";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import TYDataGrid from "shared-component/data-grid";
import DisplayLabel from "shared-component/display-label";
import { useStyles } from './style';
import { JobDetail } from "pages/c-dad-user-data";

dayjs.extend(utc);

interface RawDataProps {
  jobDetails: JobDetail[],
  cDadUnNestedDataValue: any,
  pageNo: number
}

const RawData = (props: RawDataProps) => {
  const { jobDetails, cDadUnNestedDataValue } = props;
  const routeLocation = useLocation();
  const [page, setPage] = useState<number>(0);
  const [showFullRecord, setShowFullRecord] = useState<boolean>(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({});
  const [columns, setColumns] = useState<Array<GridColDef>>([]);
  const [visibleColumns, setVisibleColumns] = useState<GridColumnVisibilityModel>({});
  const style = useStyles();
  const [unnestedData] = useState(cDadUnNestedDataValue ?? []);
  const [, setSignalTipe] = useState('Both');
    console.log('cDadUnNestedDataValue', cDadUnNestedDataValue)
  useEffect(() => {
    if (routeLocation && document) {
      // 👇 Will scroll smoothly to the top of the next section
      document
        ?.getElementById("panel4")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  }, [routeLocation]);

  useEffect(() => {
    if (unnestedData.data && unnestedData.data?.length) {
      let newCol: GridColDef[] = Object.entries(unnestedData.data[0])
        .map(([key, value]) => {
          if (key === "vin") {
            return {
              field: key,
              headerName: key,
              minWidth: 350,
              sortable: false,
              renderCell: (params) => {
                return <Typography>{params.value}</Typography>;
              },
            };
          } else if (key === "gpsDateTime") {
            return {
              field: key,
              headerName: key,
              minWidth: 250,
              sortable: false,
              renderCell: (params) => {
                return <Typography>{params.value}</Typography>;
              },
            };
          }
          return {
            field: key,
            headerName:
              Array.isArray(value) && value.length > 1
                ? `${key} (${value[1]})`
                : key,
            minWidth: 150,
            sortable: false,
            hide: true,
            renderCell: (params) => {
              return (
                <Typography>
                  {typeof params?.value === "object"
                    ? params?.value &&
                    params?.value.length > 0 &&
                    params?.value[0]
                    : params.value}
                </Typography>
              );
            },
          };
        });

      newCol = newCol.filter((c) => c.field !== "row_num");

      setColumns([
        {
          field: "Action",
          headerName: "Action",
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          hideable: false,
          renderCell: (params) => (
            <Tooltip title="View full details">
              <IconButton
                onClick={() => {
                  setSelectedRecord(params.row);
                  setShowFullRecord(true);
                }}
              >
                <RemoveRedEyeRounded />
              </IconButton>
            </Tooltip>
          ),
        },
        ...newCol,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unnestedData.data]);

  const renderFullrecord = () => {
    return selectedRecord ? (
      <Grid container spacing={2}>
        {Object.entries(selectedRecord).map(([key, value]) => {
          let labelValue: string | number = "0";
          if (value) {
            if (Array.isArray(value)) {
              labelValue = `${value[0] ?? "0"} ${value[1] ?? ""}`;
            } else if (typeof value === "string" || typeof value === "number") {
              labelValue = value?.toString();
            } 
          }

          return (
            <Grid item key={key ?? ""} xs={12} sm={6}>
              <DisplayLabel key={key ?? ""} title={key} value={labelValue} />
            </Grid>
          );
        })}
      </Grid>
    ) : null;
  };

  const handlePageChange = (newpage: number) => {
    setPage(newpage);
  };

  const filterRawData = (signalType: string) => {
    setSignalTipe(signalType)
    setPage(0)
  }
  console.log(unnestedData)

  return (
    <Box>
      <Box
        sx={{
          display: {
            md: "flex",
            sm: "flex",
            xs: "none",
          },
        }}
        alignItems={"center"}
      >
        <Box flex={1}>
          {jobDetails.map((item: JobDetail) => (
            <Typography key={item.id} fontWeight={"600"}>
              <span>
                {item.title}:{" "}
              </span>
              <span>
                {item.value}
              </span>
            </Typography>
          ))}
        </Box>
      </Box>
      <Paper
        elevation={2}
        sx={{
          marginTop: "10px",
          padding: 1,
        }}
      >
        <div className={style.dataWrap}>
          <div className="radioBtnWrap" style={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', right: '20px', top: '20px' }}>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">Data Type</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel value="CAN300" control={<Radio onChange={() => filterRawData('CAN')} sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                  },
                }} />} label="CAN300" />
                <FormControlLabel value="51F" control={<Radio onChange={() => filterRawData('51F')} sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                  },
                }} />} label="51F" />
                <FormControlLabel value="Both" control={<Radio onChange={() => filterRawData('Both')} sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: 18,
                  },
                }} />} label="Both" />
              </RadioGroup>
            </FormControl>
          </div>
          
          <TYDataGrid
            rows={unnestedData.data ?? []}
            columns={columns}
            loading={false}
            rowCount={
              unnestedData?.data.total}
            pageNo={page}
            updatepageData={handlePageChange}
            columnVisibility={visibleColumns}
            setColumnVisibility={setVisibleColumns}
          />
        </div>
      </Paper>
      <Dialog open={showFullRecord} onClose={() => setShowFullRecord(false)}>
        <DialogTitle>
          <Typography fontWeight={"bold"}>Complete unnestedData</Typography>
          <IconButton
            aria-label="close"
            onClick={() => setShowFullRecord(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box display={"flex"} alignItems={"center"} flexWrap={"wrap"}>
            {renderFullrecord()}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RawData;